import { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { Routes, Route } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import ContentPage from '../admin/content-page';
import LayoutContainer from '../layout/layout-container';
import layoutRoute from '../layout/layout-route';
import withRouter from '../../hoc/withRouter';
import { check } from '../../utils/tokenUtils';
import store from '../../store';
import { getMyProfile } from '../../actions/user';
import { adminMainRoutes, emptyRoutes, mainRoutes, repRoutes, routes, adminRoutes } from '../../data/routes';
import getFeatures from '../../actions/features';
import NotFound from '../layout/not-found/index';
import ContentLayout from '../layout/content-layout/content-layout.jsx';
import EmptyLayout from '../layout/empty';
import MainLayout from '../layout/main';
import AdminLayout from '../layout/admin-layout';
import RepLayout from '../layout/rep-layout/rep-layout';
import Maintenance from '../maintenance';
import ImageViewer from '../admin/submissions/form/image-viewer';
import NoLayout from '../layout/no/index.jsx';

import './App.css';

class App extends Component {
  setPermission = permissions => ({
    action: permissions ? permissions.action : true,
    subjectClass: permissions ? permissions.subjectClass : '',
  });

  constructor(props) {
    super(props);

    this.state = {
      showMaintenanceMode: false
    };

    store.dispatch(getFeatures());

    if (check()) {
      store.dispatch(getMyProfile('CURRENT_USER_PROFILE'));
    } else {
      store.dispatch({type: 'SET_VIEWCONFIG_LOADED'});
    }
  }

  homePages = () => {
    if (check()) {
      return layoutRoute(MainLayout, {
        private: true,
        ...routes.loggedInHome,
        ...this.setPermission(routes.loggedInHome.permissions),
      }, 'home');
    }
    return layoutRoute(MainLayout, { ...routes.preLogInHome }, 'home');
  };

  publicPages = () => {
    if (!check()) {
      return routes.public.map((item, key) => layoutRoute(MainLayout, { ...item }, `public-${key}`));
    }
    return null;
  }

  adminPages = () => adminRoutes.map((item, key) => layoutRoute(AdminLayout, {
    private: true,
    ...item,
    ...this.setPermission(item.permissions),
    ...this.props.viewConfig,
  }, `admin-extra-${key}`))

  getParams = () => {
    const params = {};

    window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      (_, key, value) => { (params[key] = value); }
    );

    return params;
  }

  handleMaintenanceSkip = () => {
    const params = this.getParams();

    if (
      process.env.REACT_APP_MAINTENANCE_MODE === 'true' &&
      params.secret !== 'true' &&
      sessionStorage.getItem('maintenanceSkip') !== 'true'
    ) {
      this.setState({
        showMaintenanceMode: true
      });
    } else if (
      params.secret === 'true' ||
      sessionStorage.getItem('maintenanceSkip') === 'true'
    ) {
      this.setState({
        showMaintenanceMode: false
      }, () => {
        sessionStorage.setItem('maintenanceSkip', 'true');
      });
    }
  }

  componentDidMount = () => {
    this.handleMaintenanceSkip();
  }

  componentDidUpdate = () => {
    const params = this.getParams();

    if (
      (params.secret === 'true' ||
      sessionStorage.getItem('maintenanceSkip') === true) &&
      this.state.showMaintenanceMode === true
    ) {
      this.handleMaintenanceSkip();
    }
  }

  componentWillUnmount = () => {
    if (sessionStorage.getItem('maintenanceSkip') === true) {
      sessionStorage.removeItem('maintenanceSkip');
    }
  }

  render() {
    const {
      setPermission, adminPages, homePages, publicPages
    } = this;

    if (check() && !this.props.userProfile.id) {
      return null;
    }

    // Maintenance mode must block every route. v6 ranks specific routes above a
    // catch-all, so we short-circuit before <Routes> rather than relying on route order.
    if (this.state.showMaintenanceMode) {
      return (
        <LayoutContainer>
          <Maintenance />
        </LayoutContainer>
      );
    }

    return (
      <LayoutContainer>
        <ToastContainer
          autoClose={5000}
          closeOnClick
          hideProgressBar
          icon={false}
          newestOnTop
          pauseOnHover
          position="top-right"
          toastClassName="ignite-toast"
        />
        <Routes>
          {homePages()}
          {publicPages()}
          {emptyRoutes.public.map((item, key) => layoutRoute(EmptyLayout, { ...item }, `empty-pub-${key}`))}
          {emptyRoutes.private.map((item, key) => layoutRoute(EmptyLayout, { private: true, ...item }, `empty-priv-${key}`))}
          {mainRoutes.private.map((item, key) => layoutRoute(MainLayout, {
            private: true, ...item, ...setPermission(item.permissions),
          }, `main-${key}`))}
          {repRoutes.private.map((item, key) => layoutRoute(RepLayout, {
            private: true, ...item, ...setPermission(item.permissions),
          }, `rep-${key}`))}
          {adminMainRoutes.map((item, key) => layoutRoute(AdminLayout, {
            private: true, ...item, ...setPermission(item.permissions), ...this.props.viewConfig,
          }, `admin-${key}`))}
          {adminPages()}

          <Route
            path="/ignite-by-imperial"
            element={<ContentLayout component={ContentPage} {...setPermission()} />}
          />
          <Route
            path="/privacy-policy.html"
            element={<ContentLayout component={ContentPage} {...setPermission()} />}
          />
          <Route
            path="/content-pages/:pageSlug"
            element={<ContentLayout component={ContentPage} {...setPermission()} />}
          />
          <Route
            path="/team/content-pages/:pageSlug"
            element={<ContentLayout rep component={ContentPage} {...setPermission()} />}
          />
          <Route path="/image-viewer" element={<NoLayout component={ImageViewer} />} />

          <Route path="*" element={<EmptyLayout component={NotFound} />} />
        </Routes>
      </LayoutContainer>
    );
  }
}

const mapStateToProps = state => ({
  location: state.location,
  viewConfig: state.viewConfig,
  userProfile: state.viewConfig.profile,
  features: state.features
});

export default withRouter(connect(mapStateToProps)(App));
